var _defs, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172 172",
    id: "svg927",
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs931"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "DVugsgjoBNMAmjEKyS7Vka",
    x1: 9.635,
    x2: 12.204,
    y1: 5.726,
    y2: 15.655,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-33.768 15.199) scale(3.58333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4",
    id: "stop9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9",
    id: "stop9702"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DVugsgjoBNMAmjEKyS7Vkb",
    x1: 35.635,
    x2: 38.205,
    y1: 5.726,
    y2: 15.655,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-33.768 15.199) scale(3.58333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4",
    id: "stop9707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9",
    id: "stop9709"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DVugsgjoBNMAmjEKyS7Vkc",
    x1: 9.635,
    x2: 12.204,
    y1: 31.726,
    y2: 41.654,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-33.768 15.199) scale(3.58333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4",
    id: "stop9714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9",
    id: "stop9716"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DVugsgjoBNMAmjEKyS7Vkd",
    x1: 35.635,
    x2: 38.205,
    y1: 31.726,
    y2: 41.654,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-33.768 15.199) scale(3.58333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4",
    id: "stop9721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9",
    id: "stop9723"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DVugsgjoBNMAmjEKyS7Vka-0",
    x1: 9.635,
    x2: 12.204,
    y1: 5.726,
    y2: 15.655,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(3.58333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4",
    id: "stop9700-6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9",
    id: "stop9702-0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DVugsgjoBNMAmjEKyS7Vkb-1",
    x1: 35.635,
    x2: 38.205,
    y1: 5.726,
    y2: 15.655,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(3.58333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4",
    id: "stop9707-7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9",
    id: "stop9709-0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DVugsgjoBNMAmjEKyS7Vkc-7",
    x1: 9.635,
    x2: 12.204,
    y1: 31.726,
    y2: 41.654,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(3.58333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4",
    id: "stop9714-6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9",
    id: "stop9716-2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "DVugsgjoBNMAmjEKyS7Vkd-1",
    x1: 35.635,
    x2: 38.205,
    y1: 31.726,
    y2: 41.654,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(3.58333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4",
    id: "stop9721-4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9",
    id: "stop9723-9"
  })))), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    id: "g925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10653"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#DVugsgjoBNMAmjEKyS7Vka)",
    d: "M50.167 57.333h-21.5c-3.942 0-7.167-3.225-7.167-7.166v-21.5c0-3.942 3.225-7.167 7.167-7.167h21.5c3.941 0 7.166 3.225 7.166 7.167v21.5c0 3.941-3.225 7.166-7.166 7.166z",
    id: "path9705",
    style: {
      fill: "#023c3c",
      strokeWidth: 3.58333,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DVugsgjoBNMAmjEKyS7Vkb)",
    d: "M143.333 57.333h-21.5c-3.941 0-7.166-3.225-7.166-7.166v-21.5c0-3.942 3.225-7.167 7.166-7.167h21.5c3.942 0 7.167 3.225 7.167 7.167v21.5c0 3.941-3.225 7.166-7.167 7.166z",
    id: "path9712",
    style: {
      fill: "#023c3c",
      strokeWidth: 3.58333,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DVugsgjoBNMAmjEKyS7Vkc)",
    d: "M50.167 150.5h-21.5c-3.942 0-7.167-3.225-7.167-7.167v-21.5c0-3.941 3.225-7.166 7.167-7.166h21.5c3.941 0 7.166 3.225 7.166 7.166v21.5c0 3.942-3.225 7.167-7.166 7.167z",
    id: "path9719",
    style: {
      fill: "#023c3c",
      strokeWidth: 3.58333,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#DVugsgjoBNMAmjEKyS7Vkd)",
    d: "M143.333 150.5h-21.5c-3.941 0-7.166-3.225-7.166-7.167v-21.5c0-3.941 3.225-7.166 7.166-7.166h21.5c3.942 0 7.167 3.225 7.167 7.166v21.5c0 3.942-3.225 7.167-7.167 7.167z",
    id: "path9726",
    style: {
      fill: "#023c3c",
      strokeWidth: 3.58333,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.833,
    cy: 39.417,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9728",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.167,
    cy: 39.417,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9730",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 39.417,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9732",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 39.417,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9734",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.833,
    cy: 132.583,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9736",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.167,
    cy: 132.583,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9738",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 132.583,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9740",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.583,
    cy: 107.5,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9742",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.583,
    cy: 93.167,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9744",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.583,
    cy: 78.833,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9746",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.583,
    cy: 64.5,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9748",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.417,
    cy: 107.5,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9750",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.417,
    cy: 93.167,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9752",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.417,
    cy: 78.833,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9754",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.417,
    cy: 64.5,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9756",
    style: {
      strokeWidth: 3.58333
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 132.583,
    r: 3.583,
    fill: "#abb4be",
    id: "circle9758",
    style: {
      strokeWidth: 3.58333
    }
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2707",
    type: "text/css"
  }, ".st0{fill:#59baea}.st1{fill:#586e7c}.st2{fill:#bbcad5}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngine);
export default __webpack_public_path__ + "static/media/engine.7b12d457701dad2274f4dc5b9ce67c8b.svg";
export { ForwardRef as ReactComponent };